import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IBookingQuery } from "components/Checkout/ConfirmBooking/ConfirmBooking";
import { ISearchForm } from "redux/searchForm";
import {
  getMetaSearchQuery,
  isOutdatedMetaSearchQuery,
  isValidMetaSearchQuery,
} from "../../validation/validateMetaRequest";
import { IMetaRedirectRequest } from "../../validation/validation.interfaces";
import { IAppConfigObject } from "appConfig.interfaces";
import DOMPurify from "dompurify";

interface IArg {
  booking: IBookingQuery;
  searchQuery: ISearchForm;
  searchRequestId: string;
  config: IAppConfigObject;
}

export const bookingApi: any = createApi({
  reducerPath: "bookingApi",
  baseQuery: fetchBaseQuery({
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "POST, GET",
      "Access-Control-Allow-Origin": "*",
    },
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    booking: builder.query({
      query: (arg: IArg) => {
        return {
          url: `${arg.config.FLIGHT_SEARCH_API_BASE_URL}/book?topLevelDomain=${arg.config.TOP_LEVEL_DOMAIN}`,
          method: "POST",
          body: JSON.parse(
            DOMPurify.sanitize(JSON.stringify(getRequestBody(arg))),
          ),
        };
      },
    }),
  }),
});

export const { useLazyBookingQuery } = bookingApi;

const getRequestBody = (arg: IArg) => {
  const bookingQuery: IBookingRequest = {
    ...arg.booking,
    searchRequestId: arg.searchRequestId,
  };

  if (
    isValidMetaSearchQuery(arg.searchQuery) &&
    !isOutdatedMetaSearchQuery(arg.searchQuery)
  ) {
    bookingQuery["metaRedirectQuery"] = getMetaSearchQuery(arg.searchQuery);
  }

  return bookingQuery;
};

interface IBookingRequest extends IBookingQuery {
  searchRequestId: string;
  metaRedirectQuery?: IMetaRedirectRequest;
}
